<template>
  <div class="edit">
    <div class="edit_top">
      <router-link to="/template/edit" class="edit_router">
        {{ edit }}
      </router-link>
    </div>
    <div class="detail">
      <div class="detail_contents">
        <div class="detail_top">
          <div class="detail_label">
            {{ titleLabel }}
          </div>
          <div class="detail_top_title">
            {{ template.title }}
          </div>
        </div>
        <div class="detail_bottom">
          <div class="detail_label">
            {{ templateLabel }}
          </div>
          <div class="detail_message">{{ template.message }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      edit: '編集',
      titleLabel: 'タイトル',
      templateLabel: '定型文'
    }
  },
  computed: {
    template() {
      return this.$store.state.template.template
    }
  },
  methods: {}
}
</script>
<style scoped>
.template_style_area {
  padding: 5px;
  display: inline-block;
  border-radius: 7px;
}
.detail_message {
  min-height: 30px;
  overflow-wrap: anywhere;
  white-space: pre-line;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/template/templateDetail.vue